const COS = require('cos-js-sdk-v5')

export default function cosClient (data) {
  // 后端提供数据
  return new COS({
    SecretId: data.tmpSecretId,
    SecretKey: data.tmpSecretKey,
    SecurityToken: data.sessionToken
  })
}
